import moment from "moment";

export const isDevelop = () => process.env.NODE_ENV.match(/develop/i);

export const getEl = (selector, idx) => {
  if (typeof document === "undefined") return null;
  return document.querySelectorAll(selector)[idx || 0];
};

export const getEls = (selector) => {
  if (typeof document === "undefined") return [];
  return document.querySelectorAll(selector);
};

export const closest = (el, selector) => {
  var matchEl = null;

  while (el) {
    if (el.matches(selector)) {
      matchEl = el;
      break;
    }
    el = el.parentElement;
  }
  return matchEl;
};

export const unbusy = () => {
  var bodyEl = app.getEl("body");

  bodyEl.classList.remove("busy");
  bodyEl.removeAttribute("data-busy");
};

export const formatPrice = (cents, after) => {
  if (typeof after === "undefined") after = "";
  var price = (Math.abs(cents) / 100.0).toFixed(2);

  return (
    (cents < 0 ? "-$" : "$") +
    price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
    after
  );
};

export const formatWholePrice = (dollars, after) => {
  if (typeof after === "undefined") after = "";

  return (
    (dollars < 0 ? "-$" : "$") +
    dollars.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
    after
  );
};

export const getInLocal = (key, shouldParse = false, defaultValue = "") => {
  let data;

  try {
    const val = localStorage.getItem(key);

    data = shouldParse ? JSON.parse(val) : val;
  } catch (err) {
    data = defaultValue;
  }
  return data || {};
};

export const setInLocal = (key, value) => {
  let data;

  try {
    localStorage.setItem(key, value);
    return true;
  } catch (err) {}
  return false;
};

export const shuffle = (arrayObj) => {
  const arr = arrayObj;

  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = arr[i];

    arr[i] = arr[j];
    arr[j] = temp;
  }
  return arr;
};

export const trackEvent = (name, props = {}) => {
  if (typeof fbq === "function") {
    const standardEvents = [
      "ViewContent",
      "Search",
      "AddToCart",
      "AddToWishlist",
      "InitiateCheckout",
      "AddPaymentInfo",
      "Purchase",
      "Lead",
      "CompleteRegistration",
    ];

    fbq(
      standardEvents.indexOf(name) > -1 ? "track" : "trackCustom",
      name,
      props
    );
  }
  if (typeof ga === "function") {
    const params = {
      eventCategory: "Website",
      eventAction: name,
    };

    if (props.content_name) params.eventLabel = props.content_name;
    if (props.eventValue) params.eventLabel = props.value;
    ga("send", "event", params);
  }
  if (isDevelop) {
    console.log(">> Track Event", name, props);
  }
};

export const buildPerksHTMLforTrip = (tripData) => {
  const perks = [...tripData.perks];
  const subPerks = [...tripData.subPerks];
  const lastPerk = perks.pop();
  let perksHTML = "";
  let subPerksHTML = "";

  perks.forEach((perk) => (perksHTML += `<li>${perk}</li>`));
  subPerks.forEach((perk) => (subPerksHTML += `<li>${perk}</li>`));
  return `
    <ul className="perks-list">
      ${perksHTML}
      <li>
        ${lastPerk}
        <ul>${subPerksHTML}</ul>
      </li>
    </ul>
  `;
};

export const getPlanChangeData = (tripData, deps) => {
  const { moment } = deps;
  const useMaxSubMonthsCutoff = moment(
    tripData.useMaxSubMonthsCutoff,
    "MM-DD-YYYY"
  );
  const availabilityCutoff = moment(tripData.availabilityCutoff, "MM-DD-YYYY");
  const today = moment(new Date());
  const maxMonths = tripData.maxSubMonths;
  let planChangeDay;
  let xMonths;

  if (today.valueOf() > useMaxSubMonthsCutoff.valueOf()) {
    let monthRemainder = 0;
    xMonths = availabilityCutoff.diff(today, "months") + 1;
    if (xMonths > maxMonths) {
      monthRemainder = xMonths - maxMonths;
      xMonths = maxMonths;
    }
    if (availabilityCutoff.valueOf() > today.valueOf()) {
      monthRemainder++;
    }
    if (
      parseInt(today.format("D"), 10) >=
      parseInt(availabilityCutoff.format("D"), 10)
    ) {
      monthRemainder++;
    }
    planChangeDay = today
      .add({ months: monthRemainder - 1 })
      .date(availabilityCutoff.subtract({ days: 1 }).date());
  } else {
    xMonths = maxMonths;
    planChangeDay = useMaxSubMonthsCutoff.subtract({ days: 1 });
  }
  return { xMonths, planChangeDay };
};

export const isHawaiiTime = () => {
  // The UTC for Hawaii is 600 minutes (10 hours)
  return new Date().getTimezoneOffset() === 600;
};

export const isUrlAllowedInHawaii = () => {
  const url = typeof window === "undefined" ? "" : window.location.href;
  return !!url.match(/\/finaldetails|finalpacket/i);
};

export const getParamFromQueryString = (param, queryString) => {
  if (typeof queryString !== "string") return "";

  const regex = new RegExp(`.*${param}=([^\&]+).*`, "g");

  return queryString.match(regex)
    ? decodeURIComponent(queryString.replace(regex, "$1"))
    : "";
};

export const getRoomPrice = (tripData, roomData, promo) => {
  try {
    if (!promo) promo = getParamFromQueryString("promo", window.location.href);
    if (
      (promo === "onlocation" || window.location.href.match(/\/onlocation/i)) &&
      tripData.onLocationPricingAvailable &&
      roomData.prices.onlocation
    )
      return parseInt(roomData.prices.onlocation, 10);
  } catch (e) {}

  const useHawaiiPricing =
    tripData.useHawaiiPricing && roomData.prices.hawaii && isHawaiiTime();

  return parseInt(roomData.prices[useHawaiiPricing ? "hawaii" : "default"], 10);
};

export const scrollDistanceToTop = (el) => {
  const headerHeight = getEl("header").offsetHeight;
  let offset = -headerHeight;
  if (el.offsetParent) {
    do {
      offset += el.offsetTop;
      el = el.offsetParent;
    } while (el);
  }
  return offset >= 0 ? offset : 0;
};

export const isIOSDevice = () => {
  return (
    typeof navigator !== "undefined" &&
    !!navigator.platform &&
    /iPad|iPhone|iPod/.test(navigator.platform)
  );
};

export const getValidCoupon = (code, coupons) => {
  const matchedCoupon = coupons.find((match) => match.code === code);

  // no valid code found for trip
  if (!matchedCoupon) return null;

  const expiration = moment.utc(matchedCoupon.expiration).valueOf();
  const now = moment(new Date()).valueOf();

  // code is expired
  if (now > expiration) return null;

  return matchedCoupon;
};



// WEBPACK FOOTER //
// ./src/utils/app-helpers.js